(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation_fixed"] && !Shopify.designMode) return;
  try {
    
  // var headerHeight = parseInt(getComputedStyle($one('.header')).height)
  // try {
  //   headerHeight += (parseInt(getComputedStyle($one('.shopify-section--announcement-bar')).height) || 0) -1;
  // } catch (error) {

  // }

  var navList = Array.prototype.filter.call($$('[navigation-title]'), function (el) {
    var title = el.getAttribute('navigation-title');
    return title && title.trim();
  });

  const styles = getComputedStyle(document.querySelector('html'));
  var headerHeight =
    (parseInt(styles.getPropertyValue('--announcement-bar-height')) || 0) +
    (parseInt(styles.getPropertyValue('--header-height')) || 0);

  $one('.navigation_fixed').style.top = headerHeight + 'px';
  var html = '';
  navList.forEach(function (element) {
    var title = element.getAttribute('navigation-title');
    if (title) {
      html += '<span>' + title + '</span>';
    }
  });
  if (html) {
    $one('.navigation_fixed .q_pageBox-box').innerHTML = html;
    $one('.navigation_fixed').classList.add('active');
  }

  $$('.q_pageBox-box > span').forEach(function (element, index) {
    element.addEventListener('click', function (event) {
      const styles = getComputedStyle(document.querySelector('html'));
      var headerHeight =
        (parseInt(styles.getPropertyValue('--announcement-bar-height')) || 0) +
        (parseInt(styles.getPropertyValue('--header-height')) || 0);

      var top =
        getTopDistance(navList[index]) - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight;
      $$('.q_pageBox-box > span').forEach(function (el, ii) {
        el.classList.remove('active');
      });
      element.classList.add('active');
      window.scrollTo(0, top);
    });
  });

  var pageHeight = document.documentElement.scrollHeight;
  var viewportHeight = window.innerHeight;
  window.addEventListener('scroll', () => {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    for (var i = navList.length - 1; i >= 0; i--) {
      if (
        scrollTop >
        getTopDistance(navList[i]) - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight - 2
      ) {
        $$('.q_pageBox-box > span').forEach(function (el, ii) {
          el.classList.remove('active');
        });
        $$('.q_pageBox-box > span')[i].classList.add('active');
        return false;
      }
    }
  });

  function getTopDistance(element) {
    var top = element.getBoundingClientRect().top;
    return Math.round(top + window.scrollY);
  }

  } catch(e) { console.error(e); }
})();
})();
